export const validatePasswordRequirements = (password: string) => {
  if (password.length < 8) {
    return false;
  }
  let hasUppercase = false;
  let hasLowercase = false;
  let hasNumber = false;
  let hasSpecialChar = false;
  for (const char of password) {
    if (char >= "A" && char <= "Z") {
      hasUppercase = true;
    } else if (char >= "a" && char <= "z") {
      hasLowercase = true;
    } else if (char >= "0" && char <= "9") {
      hasNumber = true;
    } else {
      hasSpecialChar = true;
    }

    if (hasUppercase && hasLowercase && hasNumber && hasSpecialChar) {
      return true;
    }
  }

  return hasUppercase && hasLowercase && hasNumber && hasSpecialChar;
};
